import { Epic } from 'redux-observable';
import 'rxjs';
import CheckoutServiceV2 from 'src/js/enrol/services/CheckoutApiService';
import { FULFILLED } from '../../common/actions/ActionUtils';
import * as EpicUtils from '../../common/epics/EpicUtils';
import { SELECT_ITEM_REQUEST, updateItem } from '../containers/summary/actions/Actions';

const request: EpicUtils.Request<any, any> = {
  type: SELECT_ITEM_REQUEST,
  getData: CheckoutServiceV2.updateItem,
  processData: (value: any) => [
    { type: FULFILLED(SELECT_ITEM_REQUEST) },
    updateItem(value),
  ],
};

export const EpicItemSelect: Epic<any, any> = EpicUtils.Create(request);
